import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

export function ErrorIcon({ className, size = 20, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4451 4.01802L2.64059 17.8677C1.8893 19.2009 2.85265 20.8496 4.38298 20.8496H19.6177C21.1297 20.8496 22.0948 19.2365 21.38 17.9041L13.9499 4.05438C13.2044 2.66488 11.2192 2.64429 10.4451 4.01802ZM12.863 9.37951C12.8734 8.89679 12.4849 8.49988 12.002 8.49988C11.5194 8.49988 11.131 8.89644 11.1411 9.37895L11.253 14.7535C11.2615 15.1601 11.5936 15.4854 12.0003 15.4854C12.4069 15.4854 12.7389 15.1604 12.7476 14.754L12.863 9.37951ZM11.291 18.1907C11.4879 18.3968 11.7243 18.4999 12.0001 18.4999C12.1819 18.4999 12.347 18.4532 12.4955 18.3598C12.647 18.2632 12.7682 18.1343 12.8592 17.9733C12.9531 17.8123 13.0001 17.6335 13.0001 17.4371C13.0001 17.1472 12.9001 16.8992 12.7001 16.6931C12.5031 16.487 12.2698 16.3839 12.0001 16.3839C11.7243 16.3839 11.4879 16.487 11.291 16.6931C11.097 16.8992 11.0001 17.1472 11.0001 17.4371C11.0001 17.7334 11.097 17.9846 11.291 18.1907Z"
        fill="currentColor"
      />
    </svg>
  )
}
